//App.js
import React, {
  useReducer,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { Route, Switch } from "react-router-dom";
import "./axiosConfig";
import swrConfig from "./swrConfig";

import listPageReducer from "./listPageReducer";
import calendarReducer from "./calendarReducer";
import initialState from "./initialState";
import initialStateList from "./initialStateList";
import axios from "axios";
import Login from "./login";
import Logout from "./logout";
// import AuthHelperMethods from "./AuthHelperMethods";
import { positions, Provider as AlertProvider } from "react-alert";
//import CalendarHome from "./Calendar";
import posthog from "posthog-js";
import decode from "jwt-decode";

import RingLoader from "react-spinners/RingLoader";
import LoadingOverlay from "react-loading-overlay";

import PrivateRoute from "./privateRoute";
import AlertTemplate from "./alert_template";
import AdmRoute from "./admRoute";
import ClientHome from "./clientHomePage";
import Public from "./public";
import PublicAvailability from "./publicAvailability";
import {
  ChangePassword,
  PasswordFromToken,
  // ValidatePasswordToken,
  //CreatePasswordFromToken,
  WaiverNewAccountRedirect,
} from "./login";
import { Toaster, toast } from "react-hot-toast";
import GlobalErrorBanner from "./globalErrorBanner";
import { VersionBanner } from "./versionBanner";

import { SWRConfig, mutate } from "swr";

//import LogoutConfirm from "./logoutConfirm";
import { MyContext, ListContext } from "./MyContext"; // ← add this
import Auth from "./Auth";

//export const MyContext = React.createContext(null);
//export const ListContext = React.createContext(null);
axios.defaults.baseURL = import.meta.env.VITE_DATA_API;

let networkErrorToastShown = false;

if (process.env.NODE_ENV === "development") {
  window.axios = axios;
}

function laggy(useSWRNext) {
  return (key, fetcher, config) => {
    // Use a ref to store previous returned data.
    const laggyDataRef = useRef();
    // Actual SWR hook.
    const swr = useSWRNext(key, fetcher, config);
    useEffect(() => {
      // Update ref if data is not undefined.
      if (swr.data !== undefined) {
        laggyDataRef.current = swr.data;
      }
    }, [swr.data]);

    // Expose a method to clear the laggy data, if any.
    const resetLaggy = useCallback(() => {
      laggyDataRef.current = undefined;
    }, []);

    // Fallback to previous data if the current data is undefined.
    const dataOrLaggyData =
      swr.data === undefined ? laggyDataRef.current : swr.data;
    // Is it showing previous data?
    const isLagging =
      swr.data === undefined && laggyDataRef.current !== undefined;

    // Also add a `isLagging` field to SWR.
    return Object.assign({}, swr, {
      data: dataOrLaggyData,
      isLagging,
      resetLaggy,
    });
  };
}

const App = () => {
  LoadingOverlay.propTypes = undefined;

  const [mystate, dispatch] = useReducer(calendarReducer, initialState);
  const [listState, dispatch2] = useReducer(listPageReducer, initialStateList);
  const [globalError, setGlobalError] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 500);

  /*
  if (process.env.NODE_ENV == "production") {
    console.log = function () {};
  }
  */
  useEffect(() => {
    console.log("globalError changed (provider):", JSON.stringify(globalError));
  }, [globalError]);
  useEffect(() => {
    console.log("[App] App component mounted or re-mounted");
  }, []);

  useEffect(() => {
    Auth.onError = setGlobalError;
  }, []);

  useEffect(() => {
    const handleGlobalApiError = (event) => {
      if (!event?.detail) return;
      setGlobalError(event.detail);
    };

    window.addEventListener("global-api-error", handleGlobalApiError);
    return () => {
      window.removeEventListener("global-api-error", handleGlobalApiError);
    };
  }, []);

  // Posthog Identify on page load/refresh
  useEffect(() => {
    console.log("Identify on page load/refresh");
    const token = localStorage.getItem("auth_token");
    if (token && posthog) {
      try {
        const { user_name, username, farm_name, user_type_description } =
          decode(token);
        /*  const identityId =
          `${username} ${farm_name || mystate.farmDefaults.farm_name} ${user_type_description || ""}`.trim();
        console.log(identityId);
        */
        // if (identityId) {
        console.log("username");
        console.log(username);

        if (username) {
          posthog?.identify(username, {
            username,
            user_name,
            ...(farm_name && { farm_name }),
            ...(user_type_description && { user_type_description }), // add this guard
            //farm_name: farm_name || mystate.farmDefaults.farm_name,
          });
        }
      } catch (e) {
        console.error("Failed to decode auth token", e);
      }
    }
  }, [posthog]);

  // Separate effect to update farm_name once it loads
  useEffect(() => {
    if (mystate.farmDefaults.farm_name && posthog) {
      posthog?.setPersonProperties({
        farm_name: mystate.farmDefaults.farm_name,
      });
    }
  }, [mystate.farmDefaults.farm_name, posthog]);

  useEffect(() => {
    if (posthog) {
      posthog?.register({ app_version: "20261112.1" });
    }
  }, [posthog]);

  const alertOptions = {
    position: positions.TOP_CENTER,
    timeout: 5000,
    offset: "0",
  };

  return (
    <>
      <MyContext.Provider
        value={{
          mystate,
          dispatch,
          setGlobalError,
          globalError,
        }}
      >
        <ListContext.Provider value={{ listState, dispatch2 }}>
          <SWRConfig value={swrConfig(setGlobalError, dispatch)}>
            <GlobalErrorBanner />
            {/*} <VersionBanner /> */}
            <LoadingOverlay
              active={mystate.isFetching}
              fadeSpeed={1}
              styles={{
                overlay: (base) => ({
                  ...base,
                  background: "rgba(245, 238, 237, 0.5)",
                }),
              }}
            >
              <div
                className="sweet-loading"
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "60%",
                  transform: "translate(-50%, -50%)",
                  zIndex: "50000",
                  textAlign: "center",
                }}
              >
                <RingLoader
                  css={{}}
                  sizeUnit={"px"}
                  size={300}
                  color={"#ff7900"}
                  loading={mystate.isFetching}
                />
              </div>

              <>
                <AlertProvider template={AlertTemplate} {...alertOptions}>
                  <div
                    className="app"
                    style={{
                      display: "flex",
                      maxWidth: "100vw",
                      xjustifyContent: "center",
                      flexWrap: "nowrap",
                      background: "white",
                    }}
                  >
                    <Switch>
                      <Route path="/login" component={Login} />
                      <PrivateRoute
                        path="/clienthome/:id"
                        component={ClientHome}
                      />
                      <Route path="/logout" component={Logout} />
                      <PrivateRoute path="/admin" component={AdmRoute} />
                      <Route path="/password" component={ChangePassword} />

                      <Route
                        path="/updatepassword/:token"
                        render={() => <PasswordFromToken mode="create" />}
                      />
                      <Route
                        path="/resetpassword/:token"
                        render={() => <PasswordFromToken mode="reset" />}
                      />
                      <Route
                        path="/waivercompletion"
                        component={WaiverNewAccountRedirect}
                      />

                      <Route exact path="/" component={Login} />
                      <Route path="/public/:public_id" component={Public} />
                      <Route
                        path="/publicBook/:public_id"
                        component={PublicAvailability}
                      />
                    </Switch>
                  </div>
                </AlertProvider>
              </>
            </LoadingOverlay>
          </SWRConfig>
        </ListContext.Provider>
      </MyContext.Provider>
    </>
  );
};

export default App;
